import React from "react";

import "../styles/Intro.css";
import Typist from "react-typist";
import "react-typist/dist/Typist.css";
import EmailRoundedIcon from "@material-ui/icons/EmailRounded";
import FadeInSection from "./FadeInSection";

class Intro extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1",
      visible: true,
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey,
    });
  }
  render() {
    return (
      <div id="intro">
        <div className="intro-image">
        <img src="/assets/me.png" alt="Ander Alvarez" />
        </div>
        <Typist avgTypingDelay={120}>
          <span className="intro-title">
            {"Hi, "}
            <span className="intro-name">{"Ander"}</span>
            {" here."}
          </span>
        </Typist>
        <FadeInSection>
          <div className="intro-subtitle">Telecommunications Engineer working in the software industry, combining the best of both worlds</div>
          <div className="intro-desc"/>
          <a
            href="mailto:anderalvarez15@gmail.com"
            target="_blank"
            className="intro-contact"
          >
            <EmailRoundedIcon></EmailRoundedIcon>
            {"Contact me!"}
          </a>
        </FadeInSection>
      </div>
    );
  }
}

export default Intro;
